// src/screens/WinnerScreen.jsx
import { Btn, T } from "../components/ui.jsx";

const ROLE_STYLES = {
  mafia:   { bg: "rgba(122,20,20,0.3)",  border: "var(--blood)",  color: "#e05555",  icon: "🔪" },
  doctor:  { bg: "rgba(26,92,92,0.3)",   border: "#2a8080",       color: "#4db8b8",  icon: "💊" },
  citizen: { bg: "rgba(26,42,74,0.3)",   border: "#2a4080",       color: "#6080c0",  icon: "🏛️" },
};

export default function WinnerScreen({ state, me, onPlayAgain, onQuit }) {
  const w        = state.winner;
  const isTown   = w === "town" || w === "town_doctors";
  const players  = state.players || [];

  return (
    <div style={{ ...T.screen, textAlign: "center", padding: "2rem 1rem" }}>
      {/* Title */}
      <div style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(2rem,7vw,4rem)", fontWeight: 900, color: isTown ? "var(--gold)" : "#e05555", marginBottom: "0.4rem" }}>
        {isTown ? "🏛️ Town Wins!" : "🔪 Mafia Wins!"}
      </div>

      {/* Sub */}
      <div style={{ fontSize: "clamp(0.85rem,2vw,1rem)", color: "rgba(242,234,216,0.6)", marginBottom: "2rem", lineHeight: 1.8 }}>
        {w === "town_doctors"
          ? "The two Doctors identified each other,\nleaving only the Mafia exposed. Justice prevails."
          : isTown
            ? "All Mafia members have been eliminated.\nThe town is safe once more."
            : "The Mafia outnumbered the town.\nSilence falls over the streets."}
      </div>

      {/* Final roles reveal */}
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "0.6rem", marginBottom: "2rem", maxWidth: 560 }}>
        {players.map((p) => {
          const rs = ROLE_STYLES[p.role] || ROLE_STYLES.citizen;
          return (
            <div key={p.id} style={{ padding: "0.5rem 0.9rem", borderRadius: 2, fontSize: "clamp(0.7rem,2vw,0.82rem)", background: rs.bg, border: `1px solid ${rs.border}`, color: rs.color }}>
              {rs.icon} {p.name} — {p.role?.toUpperCase()}
            </div>
          );
        })}
      </div>

      {/* Play again + wait message */}
      {me.isHost ? (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "0.75rem", width: "100%", maxWidth: 300 }}>
          <Btn onClick={onPlayAgain} style={{ maxWidth: 300 }}>↩ Play Again</Btn>
           <Btn variant="danger" onClick={onQuit}>✕ Quit & Delete Room</Btn>
          <div style={{ fontSize: "0.68rem", color: "rgba(242,234,216,0.3)", letterSpacing: "0.1em" }}>
            As host, clicking resets the room for everyone.
          </div>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "0.75rem", width: "100%", maxWidth: 300 }}>
          <div style={{ padding: "1rem 1.5rem", border: "1px solid rgba(201,168,76,0.2)", borderRadius: 2, background: "rgba(201,168,76,0.04)", color: "rgba(242,234,216,0.45)", fontSize: "0.78rem", lineHeight: 1.7, animation: "pulse 1.8s ease-in-out infinite", textAlign: "center" }}>
            Waiting for the host to start a new game...
          </div>
          <Btn variant="danger" onClick={onQuit}>✕ Leave Room</Btn>
        </div>
      )}
    </div>
  );
}
